import { writable } from 'svelte/store';

let delimiter = "•"

export const panel_state = writable('contracted');
export const about_panel_state = writable(false);

export const doc = writable({
    "title": "",
    "units": '',
    "unit_type": "pages",
    "current_page": "Plot",
    "boards": {
        //tracks on each board:
        "Plot": [
            //track with modules:
            { 'modules': [{ 'type':'tension curve'},{ 'type': 'plot card' }] }
        ],
        "Setting": [{}],
        "Characters": [
            { 'modules': [{ 'type': 'char card' }, { 'type': 'socionics' }] }
            //{'modules': [{ 'type': 'char card' }]}
        ]
    }
})
